import {mapGetters} from "vuex";

export default {
    data() {
        return {
            googleMapsApiKey: window.application.googleMapsApiKey || ''
        }
    },
    computed: {
        ...mapGetters('app', ['settings']),
    }
}
